/* eslint-disable import/no-extraneous-dependencies */
import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { AuthProvider } from '@/features/auth/context/authProvider'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LicenseInfo } from '@mui/x-license'
import { MUI_LICENSE_KEY } from 'config'
import App from './App'
import './index.css'
import './lib/localisation/i18n'
import './assets/styles/base/typography.scss'
import './config/Grid/Grid.scss'
import { SnackbarProvider } from './shared/components/Snackbar/SnackbarProvider'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: 0
    }
  }
})

LicenseInfo.setLicenseKey(MUI_LICENSE_KEY)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <SnackbarProvider>
            <App />
          </SnackbarProvider>
        </LocalizationProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
